import clsx from 'clsx'

export type ReviewDotColor = 'red' | 'yellow' | 'green'

export type ReviewDotProps = {
  color: ReviewDotColor
  className?: string
}

const colorStyles: Record<ReviewDotColor, string> = {
  red: 'bg-red-500',
  yellow: 'bg-yellow-500',
  green: 'bg-green-500',
}

export function ReviewDot({ color, className }: ReviewDotProps) {
  return <span className={clsx('inline-block size-[10px] rounded-full flex-shrink-0', colorStyles[color], className)} aria-hidden="true" />
}
